<script>
export default {
  data() {
    return {
      VisaSel: ["Select", "Passport", "Visa"],
      isPasswordVisible: false,
    };
  },
  methods: {
    togglePasswordVisibility() {
      this.isPasswordVisible = !this.isPasswordVisible;
    },
    submitForm() {
      this.$router.push("/provider-settings/verification");
    },
    submitFormOne() {
      this.$router.push("/provider-settings/provider-security-settings");
    },
  },
};
</script>
<template>
  <!-- Upload Document -->
  <div
    class="modal fade verification-document"
    id="upload-document"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-0"
        >
          <h5>Document Verification</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitForm">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Full Name</label>
                  <div class="pass-group">
                    <input type="password" class="pass-input form-control" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Document Type</label>
                  <vue-select :options="VisaSel" id="visasel" placeholder="Select" />
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Document Number</label>
                  <div class="pass-group">
                    <input type="password" class="pass-input form-control" />
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label class="form-label">Address</label>
                  <div class="pass-group">
                    <input type="password" class="pass-input form-control" />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Upload Document</label>
                  <div
                    class="file-upload drag-file w-100 d-flex align-items-center justify-content-center flex-column mb-2"
                  >
                    <span class="upload-img d-block mb-2"
                      ><i class="ti ti-upload text-dark"></i
                    ></span>
                    <p class="mb-0 text-center fs-16 text-dark">
                      Drag or Click here to Upload documents
                    </p>
                    <p class="text-center fs-14">
                      Document file size does not exceed 5MB
                    </p>
                    <input type="file" accept="video/image" />
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="passport-document">
                    <div class="row w-100">
                      <div class="col-md-10">
                        <div class="d-flex align-items-center">
                          <div class="file-icon me-2">
                            <span><i class="ti ti-file"></i></span>
                          </div>
                          <div>
                            <h6 class="d-flex align-items-center fs-16">
                              Passport_For_Verification.pdf
                              <i class="ti ti-circle-check-filled text-success ms-1"></i>
                            </h6>
                            <span class="fs-14 text-gray">1.25 MB</span>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 d-flex justify-content-end align-items-center">
                        <div class="d-flex justify-content-end">
                          <a href="javascript:void(0);"
                            ><span class="d-flex align-items-center"
                              ><i class="ti ti-trash text-dark"></i></span
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-12">
                <div class="mb-3">
                  <div class="passport-document">
                    <div class="row w-100">
                      <div class="col-md-10">
                        <div class="d-flex align-items-center">
                          <div class="file-icon me-2">
                            <span><i class="ti ti-file"></i></span>
                          </div>
                          <div class="file-progress">
                            <h6 class="d-flex align-items-center fs-16 mb-2">
                              Card_debit.jpg<i
                                class="ti ti-circle-check-filled text-success ms-1"
                              ></i>
                            </h6>
                            <div class="progress progress-xs flex-grow-1 mb-1">
                              <div
                                class="progress-bar progress-bar-striped progress-bar-animated bg-primary rounded"
                                role="progressbar"
                                style="width: 80%"
                                aria-valuenow="80"
                                aria-valuemin="0"
                                aria-valuemax="100"
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-2 d-flex justify-content-end align-items-center">
                        <div class="d-flex justify-content-end">
                          <a href="javascript:void(0);"
                            ><span class="d-flex align-items-center"
                              ><i class="ti ti-loader-2 text-dark"></i></span
                          ></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div>
                <span class="text-success fs-14 d-flex align-items-center"
                  ><i class="ti ti-circle-check-filled text-success me-1"></i> Document
                  Uploaded Successfully</span
                >
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <button type="button" class="btn bg-gray" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="btn btn-dark">Submit</button>
        </div>
      </div>
    </div>
  </div>
  <!-- /Upload Document -->

  <!-- Change Email -->
  <div
    class="modal fade"
    id="change-email"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-0"
        >
          <h5>Change Email</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitFormOne">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Current Email Address</label>
                  <input type="text" class="form-control" />
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label class="form-label">New Email Address</label>
                      <input type="text" class="form-control" />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div>
                      <label class="form-label">Confirm New Password</label>
                      <div class="pass-group">
                        <input type="password" class="pass-input form-control" />
                        <span class="ti toggle-password ti-eye-off"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <button type="button" class="btn bg-gray" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="btn btn-dark">Change Email</button>
        </div>
      </div>
    </div>
  </div>
  <!-- /Change Email -->

  <!-- Change Phone Number -->
  <div
    class="modal fade"
    id="change-phone-number"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-0"
        >
          <h5>Current Phone Number</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form @submit.prevent="submitFormOne">
          <div class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <div class="mb-3">
                  <label class="form-label">Current Phone Number</label>
                  <input class="form-control" id="phone" name="phone" type="text" />
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label class="form-label">New Phone Number</label>
                      <input class="form-control" id="phone1" name="phone" type="text" />
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div>
                      <label class="form-label">Confirm New Password</label>
                      <div class="pass-group">
                        <input type="password" class="pass-input form-control" />
                        <span class="ti toggle-password ti-eye-off"></span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        <div class="modal-footer">
          <button type="button" class="btn bg-gray" data-bs-dismiss="modal">
            Cancel
          </button>
          <button type="button" class="btn btn-dark">Change Number</button>
        </div>
      </div>
    </div>
  </div>
  <!-- /Change Phone Number -->

  <!-- Delete Account -->
  <div class="modal fade custom-modal" id="del-account">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div
          class="modal-header d-flex align-items-center justify-content-between border-bottom"
        >
          <h5 class="modal-title">Delete Account</h5>
          <a href="javascript:void(0);" data-bs-dismiss="modal" aria-label="Close"
            ><i class="ti ti-circle-x-filled fs-20"></i
          ></a>
        </div>
        <form action="#">
          <div class="modal-body">
            <p class="mb-3">
              Are you sure you want to delete This Account? To delete your account, Type
              your password.
            </p>
            <div class="mb-0">
              <label class="form-label">Password</label>
              <div class="pass-group">
                <input
                  :type="isPasswordVisible ? 'text' : 'password'"
                  class="form-control pass-input"
                  placeholder="*************"
                />
                <span
                  @click="togglePasswordVisibility"
                  :class="
                    isPasswordVisible
                      ? 'toggle-password feather-eye'
                      : 'toggle-password feather-eye-off'
                  "
                ></span>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <a href="#" class="btn btn-light me-2" data-bs-dismiss="modal">Cancel</a>
            <button type="submit" class="btn btn-dark" data-bs-dismiss="modal">
              Delete Account
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <!-- /Delete Account -->
</template>
